/**
* List Scroller JS
* -----------------------------------------------------------------------------
*
* All the JS for the List Scroller component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'list-scroller',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );

      $( '.list-scroller' ).each( function() {
        if ( window.innerWidth > 1024 ) {
          const tracker = $( this ).find( '.tracker' )[0];
          const height = $( this ).outerHeight();

          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: $( this ).find( '.sections-area' )[0],
              start: 'top 50%',
              end: 'bottom 50%',
              scrub: 0,
            },
          } );
          tl.to( tracker, {scaleY: '1', ease: 'linear'}, 0 );
        }
      } );

      $( '.list-scroller .section' ).each( function() {
        if ( window.innerWidth > 1024 ) {
          let navHeight = $( '.navbar' ).height();
          navHeight += 16;
          if ( $( '#wpadminbar' ).length ) {
            navHeight += $( '#wpadminbar' ).height();
          }
          const navTrigger = ( ( navHeight / $( window ).height() ) * 100 ) + '%';
          const introHeight = $( this ).find( '.section-intro' ).outerHeight();
          const height = $( this ).outerHeight() - introHeight;

          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: '-76px ' + navTrigger,
              end: '+=' + height,
              scrub: 0,
              pin: $( this ).find( '.section-intro' )[0],
            },
          } );
        }
      } );

      $( '.list-scroller .subsection' ).each( function() {
        const height = $( this ).outerHeight();

        if ( window.innerWidth > 1024 ) {
          const tl = gsap.timeline( {
            scrollTrigger: {
              trigger: this,
              start: '0px 50%',
              end: '25% 50%',
              scrub: 0,
            },
          } );
          tl.to( this, {opacity: '1', ease: 'linear'}, 0 );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'list-scroller', COMPONENT );
} )( app );
